import { RESOURCE_API_CONFIG } from "@constants/blogs/blogs";
import axios from "axios";

export const getBlogs = async () => {
  try {
    const response = await axios.get(
      `${RESOURCE_API_CONFIG.URL}/?key=${RESOURCE_API_CONFIG.KEY}&limit=3`,
      {
        withCredentials: false,
      }
    );

    return response as any;
  } catch (error) {
    // sentryErrorLog(error);
    return {
      error,
    };
  }
};

const genTags = (tags: string[]) => {
  return tags.map((item: string) => `&filter=tag:${item}`);
};

export const getRelatedBlogs = async (tags: string[]) => {
  try {
    const tagsString = genTags(tags).join("");
    const response = await axios.get(
      `${RESOURCE_API_CONFIG.URL}/?key=${RESOURCE_API_CONFIG.KEY}&page=1&limit=4&include=authors,tags${tagsString}`
    );
    return response as any;
  } catch (error) {
    // sentryErrorLog(error);
    return {
      error,
    };
  }
};
